import { render, staticRenderFns } from "./institutionsdetail.vue?vue&type=template&id=4274d6bc&"
import script from "./institutionsdetail.vue?vue&type=script&lang=js&"
export * from "./institutionsdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports